// Utility function to truncate titles consistently across components
export var truncateTitle = function (title, maxLength) {
    if (maxLength === void 0) { maxLength = 30; }
    if (!title)
        return '';
    if (title.length <= maxLength)
        return title;
    return "".concat(title.slice(0, maxLength - 3), "...");
};
// Utility function to truncate toast message titles
export var truncateToastTitle = function (title) { return truncateTitle(title, 20); };
// Utility function to truncate card display titles
export var truncateCardTitle = function (title) { return truncateTitle(title, 35); };
// Utility function to truncate dropdown option titles
export var truncateDropdownTitle = function (title) { return truncateTitle(title, 25); };
